import {Stack} from "expo-router";
import WebHeader from "@/lib/components/WebHeader";
import {Platform} from "react-native";
import EventHeader from "@/lib/components/EventHeader";

export const unstable_settings = {
    initialRouteName: 'index',
};

export default function StackLayout() {
    return (
        <Stack
            initialRouteName={"index"}
            screenOptions={{
                header: Platform.OS === "web" ? WebHeader : undefined,
                headerBackButtonDisplayMode: "minimal",
            }}
        >
            <Stack.Screen name="index" options={{title: "Eventlista"}}/>
            <Stack.Screen name="search" options={{title: "Søk i eventer"}}/>
            <Stack.Screen name="[event_id]/index" options={{title: "Event", headerRight: EventHeader}}/>
            <Stack.Screen name="[event_id]/share" options={{title: "Del event"}}/>
            <Stack.Screen name="[event_id]/edit" options={{title: "Rediger event"}}/>
            <Stack.Screen name="[event_id]/banner" options={{title: "Velg banner"}}/>
            <Stack.Screen name="[event_id]/participants/index" options={{title: "Deltakere"}}/>
            <Stack.Screen name="[event_id]/participants/[username]/index" options={{title: "Rolle"}}/>
            <Stack.Screen name="[event_id]/invite" options={{title: "Inviter"}}/>
            <Stack.Screen name="create" options={{title: "Nytt event"}}/>
        </Stack>
    );
}